var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget__score"},_vm._l((5),function(i){return _c('div',{staticClass:"score",class:_vm.stars[i - 1]})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }